// Italian Quiz Game Data

// Quiz per bambini 6-7 anni
export const italianQuizEasy = [
  // Vocali e Consonanti
  {
    type: "vocali",
    question_it: "Quale di queste è una VOCALE?",
    question_en: "Which one is a VOWEL?",
    options: ["A", "B", "C", "D"],
    answer: 0,
    explanation_it: "A è una vocale. Le vocali sono: A, E, I, O, U",
    explanation_en: "A is a vowel. Vowels are: A, E, I, O, U"
  },
  {
    type: "vocali",
    question_it: "Quale di queste è una CONSONANTE?",
    question_en: "Which one is a CONSONANT?",
    options: ["E", "I", "M", "O"],
    answer: 2,
    explanation_it: "M è una consonante",
    explanation_en: "M is a consonant"
  },
  {
    type: "vocali",
    question_it: "Quante vocali ci sono nella parola 'CASA'?",
    question_en: "How many vowels in the word 'CASA'?",
    options: ["1", "2", "3", "4"],
    answer: 1,
    explanation_it: "CASA ha 2 vocali: A e A",
    explanation_en: "CASA has 2 vowels: A and A"
  },
  // Articoli
  {
    type: "articoli",
    question_it: "Quale articolo va con 'gatto'?",
    question_en: "Which article goes with 'gatto' (cat)?",
    options: ["Il", "La", "Lo", "Le"],
    answer: 0,
    explanation_it: "Si dice 'IL gatto' (maschile singolare)",
    explanation_en: "We say 'IL gatto' (masculine singular)"
  },
  {
    type: "articoli",
    question_it: "Quale articolo va con 'mela'?",
    question_en: "Which article goes with 'mela' (apple)?",
    options: ["Il", "La", "Lo", "I"],
    answer: 1,
    explanation_it: "Si dice 'LA mela' (femminile singolare)",
    explanation_en: "We say 'LA mela' (feminine singular)"
  },
  {
    type: "articoli",
    question_it: "Quale articolo va con 'zaino'?",
    question_en: "Which article goes with 'zaino' (backpack)?",
    options: ["Il", "La", "Lo", "Le"],
    answer: 2,
    explanation_it: "Si dice 'LO zaino' (maschile con Z)",
    explanation_en: "We say 'LO zaino' (masculine with Z)"
  },
  // Singolare e Plurale
  {
    type: "plurale",
    question_it: "Qual è il plurale di 'libro'?",
    question_en: "What is the plural of 'libro' (book)?",
    options: ["Libra", "Libri", "Libre", "Libro"],
    answer: 1,
    explanation_it: "Libro → Libri (maschile: -o diventa -i)",
    explanation_en: "Libro → Libri (masculine: -o becomes -i)"
  },
  {
    type: "plurale",
    question_it: "Qual è il plurale di 'casa'?",
    question_en: "What is the plural of 'casa' (house)?",
    options: ["Casi", "Casu", "Case", "Casa"],
    answer: 2,
    explanation_it: "Casa → Case (femminile: -a diventa -e)",
    explanation_en: "Casa → Case (feminine: -a becomes -e)"
  },
  {
    type: "plurale",
    question_it: "Qual è il singolare di 'bambini'?",
    question_en: "What is the singular of 'bambini' (children)?",
    options: ["Bambina", "Bambino", "Bambine", "Bambinu"],
    answer: 1,
    explanation_it: "Bambini → Bambino",
    explanation_en: "Bambini → Bambino"
  },
  // Parole base
  {
    type: "parole",
    question_it: "Come si chiama l'animale che fa 'miao'?",
    question_en: "What is the animal that says 'meow'?",
    options: ["Cane", "Gatto", "Mucca", "Gallina"],
    answer: 1,
    explanation_it: "Il gatto fa 'miao'!",
    explanation_en: "The cat says 'meow'!"
  }
];

// Quiz per bambini 8-10 anni
export const italianQuizHard = [
  // Verbi - Presente
  {
    type: "verbi",
    question_it: "Completa: 'Io _____ a scuola' (andare)",
    question_en: "Complete: 'Io _____ a scuola' (to go)",
    options: ["vai", "vado", "va", "andiamo"],
    answer: 1,
    explanation_it: "Io VADO (prima persona singolare di andare)",
    explanation_en: "Io VADO (first person singular of 'andare')"
  },
  {
    type: "verbi",
    question_it: "Completa: 'Tu _____ la pizza' (mangiare)",
    question_en: "Complete: 'Tu _____ la pizza' (to eat)",
    options: ["mangia", "mangio", "mangi", "mangiano"],
    answer: 2,
    explanation_it: "Tu MANGI (seconda persona singolare)",
    explanation_en: "Tu MANGI (second person singular)"
  },
  {
    type: "verbi",
    question_it: "Completa: 'Noi _____ italiano' (parlare)",
    question_en: "Complete: 'Noi _____ italiano' (to speak)",
    options: ["parlo", "parla", "parliamo", "parlano"],
    answer: 2,
    explanation_it: "Noi PARLIAMO (prima persona plurale)",
    explanation_en: "Noi PARLIAMO (first person plural)"
  },
  // Verbi - Passato
  {
    type: "verbi_passato",
    question_it: "Completa: 'Ieri io _____ al parco' (andare)",
    question_en: "Complete: 'Ieri io _____ al parco' (to go)",
    options: ["vado", "sono andato", "andrò", "andavo"],
    answer: 1,
    explanation_it: "Ieri = passato prossimo: SONO ANDATO",
    explanation_en: "Yesterday = past tense: SONO ANDATO"
  },
  {
    type: "verbi_passato",
    question_it: "Completa: 'Maria _____ un libro' (leggere - passato)",
    question_en: "Complete: 'Maria _____ un libro' (to read - past)",
    options: ["legge", "ha letto", "leggerà", "leggeva"],
    answer: 1,
    explanation_it: "Maria HA LETTO (passato prossimo)",
    explanation_en: "Maria HA LETTO (past perfect)"
  },
  // Sinonimi
  {
    type: "sinonimi",
    question_it: "Qual è un SINONIMO di 'bello'?",
    question_en: "What is a SYNONYM of 'bello' (beautiful)?",
    options: ["Brutto", "Carino", "Triste", "Piccolo"],
    answer: 1,
    explanation_it: "Bello = Carino (hanno lo stesso significato)",
    explanation_en: "Bello = Carino (they have the same meaning)"
  },
  {
    type: "sinonimi",
    question_it: "Qual è un SINONIMO di 'grande'?",
    question_en: "What is a SYNONYM of 'grande' (big)?",
    options: ["Piccolo", "Enorme", "Corto", "Lento"],
    answer: 1,
    explanation_it: "Grande = Enorme",
    explanation_en: "Grande = Enorme (huge)"
  },
  // Contrari
  {
    type: "contrari",
    question_it: "Qual è il CONTRARIO di 'alto'?",
    question_en: "What is the OPPOSITE of 'alto' (tall)?",
    options: ["Grande", "Basso", "Lungo", "Largo"],
    answer: 1,
    explanation_it: "Alto ↔ Basso",
    explanation_en: "Alto ↔ Basso (tall ↔ short)"
  },
  {
    type: "contrari",
    question_it: "Qual è il CONTRARIO di 'veloce'?",
    question_en: "What is the OPPOSITE of 'veloce' (fast)?",
    options: ["Rapido", "Lento", "Forte", "Debole"],
    answer: 1,
    explanation_it: "Veloce ↔ Lento",
    explanation_en: "Veloce ↔ Lento (fast ↔ slow)"
  },
  // Analisi grammaticale
  {
    type: "grammatica",
    question_it: "Nella frase 'Il cane corre', qual è il VERBO?",
    question_en: "In the sentence 'Il cane corre', what is the VERB?",
    options: ["Il", "cane", "corre", "nessuno"],
    answer: 2,
    explanation_it: "CORRE è il verbo (l'azione)",
    explanation_en: "CORRE is the verb (the action)"
  },
  {
    type: "grammatica",
    question_it: "Nella frase 'La mamma cucina', qual è il SOGGETTO?",
    question_en: "In the sentence 'La mamma cucina', what is the SUBJECT?",
    options: ["La", "mamma", "cucina", "La mamma"],
    answer: 3,
    explanation_it: "LA MAMMA è il soggetto (chi fa l'azione)",
    explanation_en: "LA MAMMA is the subject (who does the action)"
  },
  {
    type: "grammatica",
    question_it: "Quale parola è un AGGETTIVO?",
    question_en: "Which word is an ADJECTIVE?",
    options: ["Correre", "Velocemente", "Bello", "Casa"],
    answer: 2,
    explanation_it: "BELLO è un aggettivo (descrive un nome)",
    explanation_en: "BELLO is an adjective (describes a noun)"
  }
];

export default { italianQuizEasy, italianQuizHard };
